import React from 'react';
import { Icon } from './Icon.js';
export const IconQueueFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "14", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("path", { d: "M15.25,11H2.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H15.25c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.25,14.5H2.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H15.25c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconQueueFill18.js.map